export const environment = {
  production: true,
  demo: false,
  isMaintenance: false,
  maintenanceScenario: 'IMPROVEMENTS',
  isProduction: true,
  apiUrl: 'https://api.portal.frauddeflect.net/api/v1/',
  domain: 'https://portal.frauddeflect.net/en-us',
  demoDashboardFdId: '0857ac00-4e45-4298-a179-aa5938b875a7',
  dashboardFdId: 'a7a7b51c-9dca-4e5d-9da1-673fdc004199',
  dashboardPartnerId: '1dd497ff-97fc-4191-8637-0e7967f38b14',
  dashboard_seller: '5f64b713-6249-4890-96cc-d1046f028dc7',
  dashboard: '53c3b55a-26f1-41b5-82e7-9a7d1beecaea',
  requestPermissionChange: 'https://forms.gle/A9yyoxhp1TBBr4uHA',
  savingsCalculatorDashboardId: '783996dd-ea44-41e9-a490-37701c103c54'

};
